import { render } from "./admin-doc.vue?vue&type=template&id=77f7a2a5&scoped=true&ts=true"
import script from "./admin-doc.vue?vue&type=script&lang=ts"
export * from "./admin-doc.vue?vue&type=script&lang=ts"

import "./admin-doc.vue?vue&type=style&index=0&id=77f7a2a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f7a2a5"]])

export default __exports__